/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GenericError
 */
export interface GenericError {
  /**
   *
   * @type {string}
   * @memberof GenericError
   */
  error: string
}

/**
 * Check if a given object implements the GenericError interface.
 */
export function instanceOfGenericError(value: object): value is GenericError {
  if (!('error' in value) || value['error'] === undefined) return false
  return true
}

export function GenericErrorFromJSON(json: any): GenericError {
  return GenericErrorFromJSONTyped(json, false)
}

export function GenericErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericError {
  if (json == null) {
    return json
  }
  return {
    error: json['error'],
  }
}

export function GenericErrorToJSON(value?: GenericError | null): any {
  if (value == null) {
    return value
  }
  return {
    error: value['error'],
  }
}
